module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAjklEQVQ4T+2U0QqDMAxFb75nbC+O5P8fEybIHPuaQUYFQduiYQiFYR/L5aS9SS7h4EM5z8xeAC6ROu7+FpGVtgZ0Zi7uawXMrNDuAlX1QURdArp7LyL3Gf4TcOvrJ3ByZ7cpp4crB/5obCLBMGvyvW8zNqo6APgsgyG9sFlTngCuQR9HZr4ttaEgDcIn2RfQQJYV2MAqTQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 105